import { render, staticRenderFns } from "./TrustedIPs.vue?vue&type=template&id=8031b804&scoped=true&"
import script from "./TrustedIPs.vue?vue&type=script&lang=js&"
export * from "./TrustedIPs.vue?vue&type=script&lang=js&"
import style0 from "./TrustedIPs.vue?vue&type=style&index=0&id=8031b804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8031b804",
  null
  
)

export default component.exports